<template>
  <v-tooltip :top="position === 'top'" :bottom="position === 'bottom'" :left="position === 'left'" :right="position === 'right'">
    <template v-slot:activator="{ on }">
      <v-chip class="ma-0 pa-1" :color="saturationColor" v-on="on" small label>
        <v-avatar left class="ml-0 mr-1">
          <v-icon>{{ icon }}</v-icon>
        </v-avatar>
        {{ Math.round(value) }}%
      </v-chip>
    </template>
    <span>{{ displayName }}</span>
  </v-tooltip>
</template>

<script>
export default {
  computed: {
    saturationColor: function () {
      var a = this.value / 100
      if (this.best !== 0) {
        a = 1 - a
      }
      const b = 120 * a
      const c = 120 - b
      // Return a CSS HSL string
      return 'hsl(' + c + ', 70%, 80%)'
    },
    displayName: function () {
      if (this.name) {
        return this.name
      }
      return this.$t('components.PercentChip.precision')
    }
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: null
    },
    position: {
      type: String,
      required: false,
      default: function () {
        return 'top'
      }
    },
    best: {
      type: Number,
      required: false,
      default: function () {
        return 0
      },
      validator: function (value) {
        return [0, 100].indexOf(value) !== -1
      }
    },
    icon: {
      type: String,
      required: false,
      default: function () {
        return 'mdi-gauge-full'
      }
    }
  }
}
</script>
